import { z } from 'zod';
/**
 * Editable task statuses (V38 Settings → Task Statuses). The four built-in task
 * statuses are keyed by the fixed TaskStatus enum; only their label + colour +
 * order are configurable per org (no custom rows — Task.status stays an enum).
 */
export const TASK_STATUS_KEYS = ['open', 'in_progress', 'done', 'cancelled'];
export function isTaskStatusKey(k) {
    return TASK_STATUS_KEYS.includes(k);
}
/** Built-in defaults (label + colour), in order. */
export const TASK_STATUS_DEFAULTS = [
    { key: 'open', label: 'Open', color: '#0e7490' },
    { key: 'in_progress', label: 'In progress', color: '#7c3aed' },
    { key: 'done', label: 'Complete', color: '#1a8a66' },
    { key: 'cancelled', label: 'Cancelled', color: '#8aaa9a' },
];
const hex = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Color must be a hex like #1a8a66');
export const taskStatusUpdateSchema = z
    .object({
    label: z.string().min(1).max(60).optional(),
    color: hex.optional(),
    position: z.number().int().min(0).optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'No fields to update' });
export const taskStatusReorderSchema = z.object({
    keys: z.array(z.enum(TASK_STATUS_KEYS)).min(1),
});
//# sourceMappingURL=task-statuses.js.map